(function () {
  'use strict';
  if (window.__scarlatCommerceReady) return;
  window.__scarlatCommerceReady = true;

  function money(value) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format((value || 0) / 100);
  }

  function initCommercialCards(scope) {
    scope.addEventListener('submit', async function(event) {
      var form = event.target.closest('form.scarlat-card-order');
      if (!form || !document.querySelector('cart-drawer')) return;
      event.preventDefault();
      if (form.dataset.adding === 'true') return;
      var drawer = document.querySelector('cart-drawer'), button = form.querySelector('[type="submit"]');
      form.dataset.adding = 'true'; button.disabled = true;
      var status = form.querySelector('[data-cart-add-status]');
      if (!status) {status=document.createElement('p');status.dataset.cartAddStatus='';status.setAttribute('role','status');form.appendChild(status);}
      status.textContent = 'Adicionando ao pedido…';
      drawer.setActiveElement(button);
      try {
        var data = new FormData(form);
        data.append('sections', drawer.getSectionsToRender().map(function(s){return s.id;}).join(','));
        data.append('sections_url', window.location.pathname);
        var response = await fetch(root+'cart/add.js',{method:'POST',body:data,headers:{'X-Requested-With':'XMLHttpRequest'}});
        var added = await response.json();
        if (!response.ok || added.status) throw Error(added.description || 'Não foi possível adicionar esta quantidade.');
        status.textContent = 'Peças adicionadas ao pedido.';
        drawer.classList.remove('is-empty');
        try {drawer.renderContents(added);} catch (_) {drawer.open(button);status.textContent='Peças adicionadas. Abra o pedido para conferir.';}
        document.dispatchEvent(new CustomEvent('cart:lines-update'));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'scarlat-card',cartData:added,productVariantId:data.get('id')});
      } catch(error) {status.textContent=error.message;}
      finally {form.dataset.adding='false';button.disabled=false;}
    });
    scope.addEventListener('click', function (event) {
      var button = event.target.closest('[data-card-quantity-choice]');
      if (!button) return;
      var card = button.closest('[data-commercial-product-card]');
      if (!card) return;
      var input = card.querySelector('[data-card-quantity]');
      if (input) input.value = button.dataset.cardQuantityChoice;
      card.querySelectorAll('[data-card-quantity-choice]').forEach(function (choice) {
        var active = choice === button;
        choice.classList.toggle('is-active', active);
        choice.setAttribute('aria-pressed', String(active));
      });
    });
  }

  function initCardGalleries() {
    document.addEventListener('click', function (event) {
      var control = event.target.closest('[data-card-image-step]');
      if (!control) return;
      var media = control.closest('.scarlat-product-card__media');
      if (!media) return;
      var photos = media.querySelectorAll('[data-card-photo-url]');
      var image = media.querySelector('.scarlat-product-card__image img');
      if (!image || photos.length < 2) return;

      var current = Number(media.dataset.cardImageIndex || 0);
      var next = (current + Number(control.dataset.cardImageStep) + photos.length) % photos.length;
      var photo = photos[next];
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = photo.dataset.cardPhotoUrl;
      image.alt = photo.dataset.cardPhotoAlt;
      media.dataset.cardImageIndex = String(next);
      media.querySelector('[data-card-image-counter]').textContent = (next + 1) + ' / ' + photos.length;
    });
  }


  var engine = window.ScarlatMixEngine;
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var cartRevision = 0, cartTimer, currentCart;
  var targetMemory = null, productCache = {}, opportunityRequest = 0;
  function saved(key) { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) { return null; } }
  function persist(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) {} }
  function target() {
    var stored = saved('scarlatOrderTarget');
    if (stored !== null) return stored.value > 0 ? Number(stored.value) : null;
    var profile = saved('scarlatMixProfile');
    return profile && profile.budget > 0 ? Number(profile.budget) : targetMemory;
  }
  function setTarget(value) {
    targetMemory = value > 0 ? Number(value) : null;
    persist('scarlatOrderTarget', { value: targetMemory });
    if (currentCart) renderCart(currentCart);
  }
  function put(scope, selector, value) {
    var el = scope.querySelector(selector); if (el) el.textContent = value;
  }
  function list(node, counts, empty) {
    if (!node) return;
    node.replaceChildren();
    var keys = Object.keys(counts);
    if (!keys.length && empty) {
      var row = document.createElement('li'); row.textContent = empty; node.appendChild(row);
    }
    keys.sort(function (a, b) { return counts[b] - counts[a]; }).forEach(function (key) {
      var li = document.createElement('li'), label = document.createElement('span'), q = document.createElement('strong');
      label.textContent = key; q.textContent = counts[key] + (counts[key] === 1 ? ' peça' : ' peças');
      li.append(label, q); node.appendChild(li);
    });
  }
  function productData(handle) {
    if (!productCache[handle]) productCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { if (!r.ok) throw Error('Produto indisponível'); return r.json(); })
      .catch(function () { delete productCache[handle]; return null; });
    return productCache[handle];
  }
  async function refreshCart() {
    var revision = ++cartRevision;
    try {
      var response = await fetch(root + 'cart?section_id=scarlat-cart-data', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw Error('Carrinho indisponível');
      var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      var script = doc.querySelector('[data-scarlat-cart-data]');
      if (!script) throw Error('Dados do pedido indisponíveis');
      var cart = JSON.parse(script.textContent);
      if (revision !== cartRevision) return;
      currentCart = cart; productCache = {}; renderCart(cart);
    } catch (_) {
      document.querySelectorAll('[data-cart-reading]').forEach(function (el) { el.textContent = 'Não foi possível consultar o pedido agora. Você pode continuar comprando normalmente.'; });
    }
  }
  function scheduleCart() { clearTimeout(cartTimer); cartTimer = setTimeout(refreshCart, 180); }
  async function renderOpportunities(panel, cart) {
    var host = panel.querySelector('[data-order-opportunities]'), block = panel.querySelector('[data-order-opportunities-block]');
    if (!host || !engine) return;
    var revision = cartRevision, request = String(++opportunityRequest);
    panel.dataset.opportunityRequest = request;
    block.hidden = true; host.replaceChildren();
    var candidates = engine.opportunities(cart.items), eligible = [];
    // Authenticated history is obtained only from the signed App Proxy, never storage.
    try {
      var historyResponse=await fetch(root+'apps/scarlat/purchase-profile',{cache:'no-store'});
      if(historyResponse.ok){var history=await historyResponse.json();if(history.authenticated){
        var present=new Set(cart.items.map(function(i){return String(i.product_id);}));
        var materials=new Set(cart.items.map(function(i){return i.is_silver===true;}));
        var own=(history.recommendations||[]).filter(function(c){return !present.has(String(c.productId))&&materials.has(c.material==='silver'||c.material==='prata-925');}).map(function(c){return Object.assign({},c,{sourceSilver:c.material==='silver'||c.material==='prata-925',reason:c.source_type==='REORDER'?'Você já comprou este modelo em outro pedido.':c.source_type==='LAST_ORDER'?'Este modelo estava no seu último pedido.':c.source_type==='PROFILE_NOVELTY'?'Esta novidade segue categorias presentes nas suas compras anteriores.':'Este acabamento aparece nas suas compras anteriores.',history:true});});
        candidates=own.filter(function(c){return ['REORDER','LAST_ORDER'].includes(c.source_type);}).concat(candidates,own.filter(function(c){return ['PROFILE_NOVELTY','PROFILE_ADJACENT'].includes(c.source_type);}));cart.authenticated=true;
      }}
    }catch(_){} // PAIR remains available if private history is temporarily unavailable.
    var seenProducts=new Set();candidates=candidates.filter(function(c){var id=String(c.productId);if(seenProducts.has(id))return false;seenProducts.add(id);return true;});
    for (var pair of candidates) {
      var product = await productData(pair.handle);
      if (revision !== cartRevision || panel.dataset.opportunityRequest !== request) return;
      if (!product) continue;
      if (!Array.isArray(product.tags) || (product.tags.indexOf('material:prata-925') !== -1) !== pair.sourceSilver) continue;
      var variant = pair.variantId ? product.variants.find(function (v) { return String(v.id) === String(pair.variantId); }) : product.variants.find(function (v) { return v.available; });
      if (!variant || !variant.available) continue;
      try {
        var checked = await fetch('https://scarlat-frete.netlify.app/.netlify/functions/scarlat-mix', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({action:'selection',items:[{id:String(variant.id),quantity:1}]})});
        if (!checked.ok) continue;
        var available = (await checked.json()).lines[0];
        if (!available || !available.published || available.stock < 1) continue;
        if (revision !== cartRevision || panel.dataset.opportunityRequest !== request) return;
        eligible.push({pair:pair,product:product,line:available});
      } catch (_) { continue; }
      if (eligible.length >= 9) break;
    }
    if (revision !== cartRevision || panel.dataset.opportunityRequest !== request) return;
    var dismissed = new Set();
    function event(name, entry) {
      var data = {source_sku:entry.pair.sourceSku,target_sku:entry.line.sku,reason_code:entry.pair.reason_code,source_type:entry.pair.source_type,authenticated:cart.authenticated === true,algorithm_version:entry.pair.algorithm_version};
      if (window.ScarlatMixV2 && window.ScarlatMixV2.track) window.ScarlatMixV2.track(name,data);
    }
    function node(tag, text) { var n=document.createElement(tag); if(text)n.textContent=text; return n; }
    function card(entry) {
      var line=entry.line, pair=entry.pair, article=node('article'); article.className='scarlat-recommendation';
      var image=node('img'); image.src=entry.product.featured_image; image.alt=line.title; image.loading='lazy'; image.width=180; image.height=180;
      var title=node('h4',line.title), origin=node('p',pair.history?'Com base nas compras desta conta.':'Você já escolheu '+pair.sourceTitle+'.'), reason=node('p',pair.reason), price=node('strong',money(line.price)), stock=node('small',line.stock+' disponíveis');
      var label=node('label','Quantidade'), qty=node('input'); qty.type='number';qty.min=1;qty.max=line.stock;qty.value=1;qty.step=1;qty.setAttribute('aria-label','Quantidade de '+line.title);label.append(qty);
      var add=node('button','Adicionar ao pedido'), link=node('a','Ver peça'), dismiss=node('button','Não mostrar esta opção'), status=node('p');status.setAttribute('role','status');add.type=dismiss.type='button';
      link.href=root+'products/'+line.handle+'?variant='+line.variantId;
      dismiss.onclick=function(){dismissed.add(line.productId);event('recommendation_dismissed',entry);article.remove();renderInitial();};
      add.onclick=async function(){
        if(!qty.reportValidity())return;add.disabled=true;status.textContent='Conferindo disponibilidade…';
        try {
          var quantity=Number(qty.value), freshCart=await(await fetch(root+'cart.js',{cache:'no-store'})).json();
          if(freshCart.items.some(function(i){return String(i.product_id)===String(line.productId);}))throw Error('Esta peça já está no pedido. Ajuste a quantidade no carrinho.');
          var response=await fetch('https://scarlat-frete.netlify.app/.netlify/functions/scarlat-mix',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({action:'selection',revalidate:true,items:[{id:line.variantId,quantity:quantity}]})});
          if(!response.ok)throw Error('Não foi possível conferir a disponibilidade.');
          var fresh=(await response.json()).lines[0];
          if(!fresh||fresh.quantity!==quantity||!fresh.published)throw Error('O estoque mudou. Confira a quantidade.');
          if(fresh.price!==line.price){line.price=fresh.price;price.textContent=money(fresh.price);throw Error('O preço foi atualizado. Confira o valor e clique novamente para adicionar.');}
          var productResponse=await fetch(root+'products/'+encodeURIComponent(line.handle)+'.js',{cache:'no-store'});
          if(!productResponse.ok)throw Error('Esta peça não está disponível agora.');
          var liveProduct=await productResponse.json(), liveVariant=liveProduct.variants.find(function(v){return String(v.id)===String(fresh.variantId);});
          if(!liveVariant||!liveVariant.available)throw Error('Esta variação não está disponível agora.');
          if(pair.history&&liveProduct.variants.filter(function(v){return v.available;}).length>1){
            if(!window.ScarlatMixV2?.reviewSelection)throw Error('Abra a peça para escolher tamanho, cor, banho ou medida.');
            window.ScarlatMixV2.reviewSelection({lines:[Object.assign({},fresh,{quantity:quantity})]},'reorder');return;
          }
          if(liveVariant.price!==line.price){line.price=liveVariant.price;price.textContent=money(liveVariant.price);throw Error('O preço foi atualizado. Confira o valor e clique novamente para adicionar.');}
          var added=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:fresh.variantId,quantity:quantity}]})});
          if(!added.ok){var error=await added.json();throw Error(error.description||'Esta quantidade não está disponível.');}
          event('recommendation_added',entry);dismissed.add(line.productId);article.remove();document.dispatchEvent(new CustomEvent('cart:lines-update'));renderInitial();
          if(window.ScarlatOpenCart)await window.ScarlatOpenCart(add);
        }catch(e){status.textContent=e.message;}finally{add.disabled=false;}
      };
      article.append(image,title,origin,reason,price,stock,label,add,link,dismiss,status);event('recommendation_shown',entry);return article;
    }
    function renderInitial(){
      host.replaceChildren();var options=eligible.filter(function(e){return !dismissed.has(e.line.productId);});
      options.slice(0,3).forEach(function(e){host.appendChild(card(e));});block.hidden=!options.length;
      if(options.length>3){var more=node('button','Ver outras opções');more.type='button';more.onclick=function(){
        var dialog=node('dialog');dialog.className='scarlat-v2-dialog';dialog.setAttribute('aria-label','Outras opções para o pedido');
        var close=node('button','Fechar'),heading=node('h3','Complete uma composição');close.type='button';close.onclick=function(){dialog.close();};dialog.append(close,heading);
        var cards=node('div');cards.className='scarlat-recommendations-grid';options.slice(0,9).forEach(function(e){cards.appendChild(card(e));});dialog.append(cards);document.body.append(dialog);
        dialog.addEventListener('close',function(){dialog.remove();more.focus();},{once:true});dialog.showModal();
      };host.appendChild(more);}
    }
    renderInitial();
  }
  function renderCart(cart) {
    if (!engine) return;
    var summary = engine.summarize(cart.items, cart.total_price), budget = target(), cents = budget ? Math.round(budget * 100) : null;
    document.querySelectorAll('[data-scarlat-pdp-cart]').forEach(function (panel) {
      put(panel, '[data-cart-count]', summary.pieces); put(panel, '[data-cart-models]', summary.models); put(panel, '[data-cart-total]', money(summary.total));
      var present = cart.items.some(function (item) { return String(item.variant_id) === panel.dataset.variantId; });
      put(panel, '[data-cart-reading]', present ? 'Esta peça já está no seu pedido. Ajuste a quantidade conforme sua necessidade.' : 'Esta peça ainda não está no seu pedido.');
      panel.querySelectorAll('[data-pdp-target-block]').forEach(function (el) { el.hidden = !cents; });
      if (cents) {
        put(panel, '[data-pdp-target]', money(cents));
        put(panel, '[data-pdp-balance]', money(Math.abs(cents - summary.total)));
        put(panel, '[data-pdp-balance-label]', summary.total > cents ? 'Passou da meta em' : 'Falta para a meta');
      }
      list(panel.querySelector('[data-cart-distribution]'), summary.categories, 'Seu pedido ainda está vazio.');
    });
    document.querySelectorAll('[data-scarlat-order-panel]').forEach(function (panel) {
      put(panel, '[data-order-total]', money(summary.total)); put(panel, '[data-order-pieces]', summary.pieces); put(panel, '[data-order-models]', summary.models);
      put(panel, '[data-order-target]', cents ? money(cents) : 'Sem meta de investimento');
      put(panel, '[data-order-balance]', cents ? money(Math.abs(cents - summary.total)) : '—');
      put(panel, '[data-order-balance-label]', !cents ? 'Meta opcional' : summary.total > cents ? 'Passou da meta em' : 'Falta para a meta');
      var progress = panel.querySelector('[data-order-progress]');
      if (progress) progress.style.width = cents ? Math.min(100, summary.total / cents * 100) + '%' : '0%';
      panel.querySelectorAll('[data-order-budget-choice]').forEach(function (b) { b.classList.toggle('is-active', Number(b.dataset.orderBudgetChoice) === budget); });
      list(panel.querySelector('[data-order-categories]'), summary.categories, 'Seu pedido ainda está vazio. Escolha os modelos e as quantidades.');
      ['roles', 'positions'].forEach(function (key) {
        list(panel.querySelector('[data-order-' + key + ']'), summary[key]);
        var block = panel.querySelector('[data-order-' + key + '-block]'); if (block) block.hidden = !Object.keys(summary[key]).length;
      });
      var consultora = panel.querySelector('[data-order-consultora]');
      if (consultora) {
        var text = 'Olá, gostaria de ajuda para conferir meu pedido Scarlat. ' + summary.pieces + ' peças, ' + summary.models + ' modelos. Investimento atual: ' + money(summary.total) + '.';
        if (cents) text += ' Meta: ' + money(cents) + '.';
        [summary.categories, summary.roles, summary.positions].forEach(function (map) { text += ' ' + Object.keys(map).map(function (k) { return k + ': ' + map[k]; }).join('; ') + '.'; });
        consultora.href = consultora.dataset.consultoraBase + '?text=' + encodeURIComponent(text);
      }
      renderOpportunities(panel, cart);
    });
  }
  function initOrderPanel(panel) {
    if (panel.dataset.intelligenceBound) return; panel.dataset.intelligenceBound = 'true';
    panel.querySelectorAll('[data-order-budget-choice]').forEach(function (b) { b.addEventListener('click', function () { setTarget(Number(b.dataset.orderBudgetChoice)); }); });
    var clear = panel.querySelector('[data-order-clear-target]'); if (clear) clear.addEventListener('click', function () { setTarget(null); });
    var form = panel.querySelector('[data-order-custom-target]');
    if (form) form.addEventListener('submit', function (event) { event.preventDefault(); if (form.reportValidity()) setTarget(Number(form.elements.target.value)); });
  }
  var ranges = { '800': '15–25 peças', '1500': '30–40 peças', '5000': '100–120 peças' };
  var priorities = {
    primeiro: ['Escolhas frequentes nos pedidos', 'Variedade para conhecer seu público', 'Peças para completar o mix', 'Opções para ampliar a faixa de valor', 'Novidades para renovar o mostruário'],
    base: ['Escolhas frequentes nos pedidos', 'Peças para completar o mix', 'Variedade para conhecer seu público', 'Opções para ampliar a faixa de valor', 'Novidades para renovar o mostruário'],
    campanha: ['Novidades para renovar o mostruário', 'Variedade para conhecer seu público', 'Escolhas frequentes nos pedidos', 'Peças para completar o mix', 'Opções para ampliar a faixa de valor']
  };
  async function initFutureTemplates(mix, answers) {
    if (window.ScarlatMixV2) return window.ScarlatMixV2.render(mix, answers);
    // V2 is the only template source. Never fetch the obsolete legacy JSON.
    var unavailable=mix.querySelector('[data-mix-template-results]');
    if(unavailable){unavailable.hidden=false;unavailable.textContent='Não conseguimos carregar a sugestão agora. Você pode continuar escolhendo as peças no catálogo.';}
    return;
    var host = mix.querySelector('[data-mix-template-results]'), other = mix.querySelector('[data-mix-other-options]');
    if (!host || !engine) return;
    var serial = String(Date.now()) + Math.random(); mix.dataset.templateRequest = serial;
    try {
      var response = await fetch(mix.dataset.templatesUrl);
      if (!response.ok) return;
      var templateData = await response.json(), templates = templateData.templates || [];
      if (!templates.length) return; // No invented templates.
      var catalogResponse = await fetch(mix.dataset.catalogUrl);
      if (!catalogResponse.ok) return;
      var catalogData = await catalogResponse.json(), skus = catalogData.skus || {};
      var matching = templates.filter(function (t) { return t.approved === true && Number(t.budget) === answers.budget; }).slice(0, 5);
      var handles = new Set();
      matching.forEach(function (t) { (t.items || []).forEach(function (line) { if (skus[String(line.sku)]) handles.add(skus[String(line.sku)].handle); }); });
      var products = {};
      await Promise.all(Array.from(handles).map(async function (handle) { products[handle] = await productData(handle); }));
      if (mix.dataset.templateRequest !== serial) return;
      var evaluated = matching.map(function (t) { return engine.evaluate(t, skus, products); }).filter(Boolean);
      var ranked = engine.rank(evaluated, answers);
      host.replaceChildren(); host.hidden = !ranked.length; other.hidden = ranked.length < 2;
      var all = false;
      function render() {
        host.replaceChildren();
        (all ? ranked : ranked.slice(0, 1)).forEach(function (t) {
          var article = document.createElement('article'), title = document.createElement('h3'), description = document.createElement('p'), items = document.createElement('ul'), button = document.createElement('button');
          title.textContent = t.title || 'Sugestão de pedido';
          description.textContent = money(t.summary.total) + ' · ' + t.summary.models + ' modelos · ' + t.summary.pieces + ' peças';
          t.items.forEach(function (line) {
            var li = document.createElement('li'), link = document.createElement('a'), d = skus[String(line.sku)];
            link.href = root + 'products/' + d.handle + '?variant=' + line.variant_id;
            link.textContent = line.quantity + ' × ' + products[d.handle].title; li.appendChild(link); items.appendChild(li);
          });
          button.type = 'button'; button.textContent = 'Adicionar sugestão ao pedido';
          button.addEventListener('click', async function () {
            button.disabled = true;
            try {
              var response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: t.items.map(function (i) { return { id: i.variant_id, quantity: i.quantity }; }) }) });
              if (!response.ok) { var error = await response.json(); throw Error(error.description || 'Confira a disponibilidade das peças.'); }
              setTarget(answers.budget);
              if (document.querySelector('cart-drawer') && window.ScarlatOpenCart) await window.ScarlatOpenCart(button);
              else window.location.href = root + 'cart';
            } catch (error) { button.textContent = error.message; button.disabled = false; }
          });
          article.append(title, description, items, button); host.appendChild(article);
        });
      }
      other.onclick = function () { all = !all; other.textContent = all ? 'Ver primeira opção' : 'Ver outras ' + (ranked.length - 1) + ' opções'; render(); };
      other.textContent = 'Ver outras ' + (ranked.length - 1) + ' opções'; render();
    } catch (_) { host.hidden = true; other.hidden = true; }
  }
  function initMix(mix) {
    if (mix.dataset.intelligenceBound) return; mix.dataset.intelligenceBound = 'true';
    function update(event) {
      var input = function (name) { return mix.querySelector('input[name="mix-' + name + '"]:checked'); };
      var b = input('budget'), m = input('moment'), c = input('channel'), p = input('position');
      var answers = { budget: Number(b ? b.value : 5000), moment: m ? m.value : 'primeiro', channel: c ? c.value : '', position: p ? p.value : '' };
      put(mix, '[data-result-budget]', money(answers.budget * 100)); put(mix, '[data-result-pieces]', ranges[String(answers.budget)]);
      put(mix, '[data-result-channel]', c ? c.dataset.label : 'Escolha onde vende'); put(mix, '[data-result-position]', p ? p.dataset.label : 'Escolha o tipo de peça');
      mix.querySelectorAll('[data-result-priority]').forEach(function (node, index) { node.textContent = priorities[answers.moment][index]; });
      if (event) { persist('scarlatMixProfile', answers); setTarget(answers.budget); }
      initFutureTemplates(mix, answers);
    }
    mix.addEventListener('change', update); update();
  }
  var storyRequest = 0;
  async function updateStory(id) {
    var story = document.querySelector('[data-scarlat-story]');
    if (!story || !id || story.dataset.variantId === String(id)) return;
    var request = ++storyRequest;
    try {
      var response = await fetch(story.dataset.productUrl + '?variant=' + id + '&section_id=' + story.dataset.sectionId);
      if (!response.ok) return;
      var doc = new DOMParser().parseFromString(await response.text(), 'text/html'), replacement = doc.querySelector('[data-scarlat-story]');
      if (replacement && request === storyRequest) {
        var microTemplate = replacement.querySelector('[data-scarlat-micro-template]');
        var currentMicro = document.querySelector('product-info [data-scarlat-product-microdescription]');
        var nextMicro = microTemplate && microTemplate.content.querySelector('[data-scarlat-product-microdescription]');
        if (currentMicro && nextMicro) currentMicro.replaceWith(nextMicro.cloneNode(true));
        story.replaceWith(replacement); if (currentCart) renderCart(currentCart); else scheduleCart();
      }
    } catch (_) { /* Keep the last valid section; never change product selection or photos. */ }
  }
  function init() {
    initCommercialCards(document); initCardGalleries();
    document.querySelectorAll('[data-scarlat-mix]').forEach(initMix);
    document.querySelectorAll('[data-scarlat-order-panel]').forEach(initOrderPanel);
    if (document.querySelector('[data-scarlat-pdp-cart], [data-scarlat-order-panel]')) scheduleCart();
    document.addEventListener('cart:lines-update', scheduleCart);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleCart);
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) { if (event.data && event.data.variant) updateStory(event.data.variant.id); });
    }
    document.addEventListener('change', function (event) {
      if (event.target.matches('product-info input[name="id"]')) updateStory(event.target.value);
    });
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('[data-scarlat-mix]').forEach(initMix);
      document.querySelectorAll('[data-scarlat-order-panel]').forEach(initOrderPanel); scheduleCart();
    });
    document.addEventListener('visibilitychange', function () { if (!document.hidden && document.querySelector('[data-scarlat-pdp-cart], [data-scarlat-order-panel]')) scheduleCart(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
